import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import withWidth from '@material-ui/core/withWidth';

import { getFormValues } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import Filter from 'components/common/Filter';
import RolesTable from 'components/settings/RolesTable';
import TabNavigation from 'components/common/TabNavigation';

import {
  fetchRoles,
  clearRoles,
} from 'redux/modules/roles';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = () => ({
  toolbar: {
    marginBottom: 16,
  },
});

class Roles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileFilterExpanded: ['xs', 'sm'].indexOf(props.width) === -1,
      limit: 10,
      offset: 0,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onMobileFilterBottonClick = this.onMobileFilterBottonClick.bind(this);
    this.onTableScroll = this.onTableScroll.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    this.props.actions.clearRoles();
  }

  componentDidMount() {
    this.onRequest();
  }

  componentWillReceiveProps(nextProps) {
    const { filters, width } = this.props;
    const { limit, offset } = this.state;
    const filtersChanged = nextProps.filters.Name
      !== filters.Name;
    let newOffset = offset;
    if (filtersChanged) {
      newOffset = 0;
    }
    if (newOffset !== offset) {
      this.setState({ offset: newOffset });
    }

    if (nextProps.width !== width) {
      this.setState({
        mobileFilterExpanded: ['xs', 'sm'].indexOf(nextProps.width) === -1,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, roles, count, loading } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Name'],
      },
    );

    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged) {
      this.onRequest();
    } else if (roles.length < count
      && this.scrollRef
      && this.scrollRef.scrollTop === 0
      && loading === 0) {
      this.onTableScroll({ target: this.scrollRef });
    }
  }

  onRequest() {
    const { actions, filters } = this.props;
    const { limit, offset } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map(key => ({
        name: key,
        operation: 'contains',
        val: filters[key],
        case_sensitivity: false,
      }))
      : null;
    actions.fetchRoles({
      limit,
      offset,
      filters: requestFilters,
      triggerLoading: true,
      push: offset > 0,
    });
  }

  onMobileFilterBottonClick() {
    this.setState({ mobileFilterExpanded: !this.state.mobileFilterExpanded });
  }

  onTableScroll(event) {
    const { offset, limit } = this.state;

    if ((event.target.offsetHeight + event.target.scrollTop) / event.target.scrollHeight > 0.9) {
      if ((this.props.roles.length - limit) >= offset) {
        this.setState({
          offset: offset + limit,
        });
      }
    }
  }

  render() {
    const { roles, count, loading, classes, filters } = this.props;
    const { mobileFilterExpanded } = this.state;
    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Roles
          </title>
        </Helmet>
        <TabNavigation
          items={[
            {
              text: 'Users',
              href: '/settings/users',
            },
            {
              text: 'Roles and Permissions',
              href: '/settings/roles',
            },
          ]}
        />
        <Filter
          form="rolesFilter"
          placeholder="Search by Role Name"
          primaryButtonText="Add New Role"
          primaryButtonHref="/settings/roles/create"
          onMobileFilterBottonClick={this.onMobileFilterBottonClick}
          mobileFilterExpanded={mobileFilterExpanded}
          filters={filters}
          showTableCount
          count={count}
          loading={loading}
          items={roles}
          beforeTable
        />
        {loading > 0 &&
          <Progress fixed />
        }
        <RolesTable
          items={roles}
          count={count}
          loading={loading}
          mobileFilterExpanded={mobileFilterExpanded}
          onScroll={this.onTableScroll}
          scrollRef={(scrollRef) => { this.scrollRef = scrollRef; }}
        />
      </Layout>
    );
  }
}

Roles.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    Name: PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    fetchRoles: PropTypes.func.isRequired,
    clearRoles: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  width: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    toolbar: PropTypes.string.isRequired,
  }).isRequired,
};

Roles.defaultProps = {};

const mapStateToProps = (store, ownProps) => {
  const rolesFilterValues = getFormValues('rolesFilter')(store);
  return {
    roles: store.roles.data,
    count: store.roles.count,
    filters: {
      ...rolesFilterValues
        && rolesFilterValues.Filter
        ? { Name: rolesFilterValues.Filter }
        : {},
    },
    loading: store.roles.loading,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchRoles,
    clearRoles,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withWidth()(Roles)),
);



// WEBPACK FOOTER //
// ./src/pages/settings/Roles.js